import { Box } from '@mui/material';
import { CheckmarkOutlinedIconBig, SortingArrowLeftIcon } from '@synergy/theme-next';
import { PoolButton } from '@synergy/components-next';
import { PoolFormattedMessage } from '@synergy/components-next';
import { ReactElement } from 'react';
import { useLocation, useNavigate } from 'react-router';

import { EmptyState } from '../../../components/empty-state/empty-state';
import { EmptyStateActions } from '../../../components/empty-state/empty-state-actions';
import { EmptyStateContent } from '../../../components/empty-state/empty-state-content';
import { EmptyStateTitle } from '../../../components/empty-state/empty-state-title';

interface LocationState {
    hasOrderLimit?: boolean;
}

export const ShoppingCartSubmit = (): ReactElement => {
    const navigate = useNavigate();
    const locationState = useLocation().state as LocationState;

    const handleBackToShopClick = (): void => {
        navigate('/');
    };

    return (
        <Box sx={{ py: 22, margin: 'auto' }}>
            <EmptyState icon={<CheckmarkOutlinedIconBig fontSize="inherit" />}>
                <EmptyStateTitle>
                    <PoolFormattedMessage id="app.cart.submit.title" />
                </EmptyStateTitle>
                <EmptyStateContent>
                    <PoolFormattedMessage
                        id={!locationState?.hasOrderLimit ? 'app.cart.submit.content' : 'app.cart.submit.orderLimit'}
                    />
                </EmptyStateContent>
                <EmptyStateActions>
                    <PoolButton
                        variant="contained"
                        startIcon={<SortingArrowLeftIcon />}
                        onClick={handleBackToShopClick}
                    >
                        <PoolFormattedMessage id="app.empty.button.backToShop" />
                    </PoolButton>
                </EmptyStateActions>
            </EmptyState>
        </Box>
    );
};
